var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAntiguaAndBarbuda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 256C0 273.535 1.768 290.657 5.127 307.2L256 322.783L506.874 307.2C510.234 290.657 512 273.535 512 256C512 238.465 510.232 221.343 506.874 204.8L256 189.217L5.127 204.8C1.768 221.343 0 238.465 0 256H0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.874 307.2H5.12695C28.846 424.05 132.151 512 256 512C379.849 512 483.154 424.05 506.874 307.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12695 204.8H506.875C483.154 87.95 379.851 0 256 0C132.149 0 28.846 87.95 5.12695 204.8V204.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.304 204.8H144.696L190.176 183.406L165.957 139.361L215.342 148.806L221.602 98.917L256 135.611L290.4 98.917L296.656 148.806L346.043 139.361L321.826 183.408L367.304 204.8Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 256C0 397.384 114.616 512 256 512L51.196 102.391C19.052 145.18 0 198.363 0 256Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.384 512 512 397.384 512 256C512 198.363 492.948 145.18 460.804 102.391L256 512Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiguaAndBarbuda);
export default __webpack_public_path__ + "static/media/antiguaAndBarbuda.7fd10c5d2f9565ebb1ae4113ad10f3a1.svg";
export { ForwardRef as ReactComponent };